import React, { useState } from 'react';
import Slider from 'react-slick';
import banner1 from '../img/m1.jpg';
import banner2 from '../img/m6.jpg';
import banner3 from '../img/m5.jpg';
import banner4 from '../img/gal3.jpg';
import banner5 from '../img/m2.jpg';
import banner6 from '../img/m4.jpg';
import banner7 from '../img/m7.jpg';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Content = () => {
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [time, setTime] = useState('');
  const [address, setAddress] = useState('');
  const [contact, setContact] = useState('');

  const handleDoctorChange = (event) => {
    setSelectedDoctor(event.target.value);
    setTime(''); // Reset time when doctor changes
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let message = `Booking Details:\n`;
    message += `Doctor: ${selectedDoctor || 'Not selected'}\n`;
    message += `Name: ${name}\n`;
    message += `Email: ${email}\n`;
    message += `Address: ${address}\n`;
    message += `Contact Number: ${contact}\n`;
    message += `Preferred Time: ${time}\n`;

    const whatsappNumber = '9140458191';
    const whatsappURL = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, '_blank');

    setSelectedDoctor(null);
    setName('');
    setEmail('');
    setTime('');
    setAddress('');
    setContact('');
  };

  // Slider settings for react-slick
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  // Array of images for the slider
  const images = [banner1, banner2, banner3, banner4, banner5, banner6, banner7];

  return (
    <div className="container py-5">
      <div className="row g-4">
        {/* Form Section */}
        <div className="col-lg-4 col-md-6">
          <div className="card shadow-sm p-3" style={{ height: '500px', overflowY: 'auto' }}>
            <h2 className="text-center mb-3">Book Appointment</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <label className="form-label fw-bold">Select Doctor:</label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="doctor1"
                    name="doctor"
                    value="Dr. Mansi Shukul"
                    checked={selectedDoctor === 'Dr. Mansi Shukul'}
                    onChange={handleDoctorChange}
                  />
                  <label className="form-check-label" htmlFor="doctor1">
                    Dr. Mansi Shukul
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="doctor2"
                    name="doctor"
                    value="Dr. Garima Gupta"
                    checked={selectedDoctor === 'Dr. Garima Gupta'}
                    onChange={handleDoctorChange}
                  />
                  <label className="form-check-label" htmlFor="doctor2">
                    Dr. Garima Gupta
                  </label>
                </div>
              </div>

              <div className="mb-2">
                <label htmlFor="name" className="form-label fw-bold">Name:</label>
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="email" className="form-label fw-bold">Email:</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="address" className="form-label fw-bold">Address:</label>
                <input
                  type="text"
                  id="address"
                  className="form-control"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="contact" className="form-label fw-bold">Contact Number:</label>
                <input
                  type="tel"
                  id="contact"
                  className="form-control"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="time" className="form-label fw-bold">Preferred Time:</label>
                <select
                  id="time"
                  className="form-select"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  required
                  disabled={!selectedDoctor}
                >
                  <option value="">Select time</option>
                  {selectedDoctor === 'Dr. Mansi Shukul' && (
                    <>
                      <optgroup label="Morning">
                        <option value="Mon Morning">Monday</option>
                        <option value="Wed Morning">Wednesday</option>
                        <option value="Fri Morning">Friday</option>
                      </optgroup>
                      <optgroup label="Evening">
                        <option value="Tue Evening">Tuesday</option>
                        <option value="Thu Evening">Thursday</option>
                        <option value="Sat Evening">Saturday</option>
                      </optgroup>
                    </>
                  )}
                  {selectedDoctor === 'Dr. Garima Gupta' && (
                    <>
                      <optgroup label="Morning">
                        <option value="Tue Morning">Tuesday</option>
                        <option value="Thu Morning">Thursday</option>
                        <option value="Sat Morning">Saturday</option>
                      </optgroup>
                      <optgroup label="Evening">
                        <option value="Mon Evening">Monday</option>
                        <option value="Wed Evening">Wednesday</option>
                        <option value="Fri Evening">Friday</option>
                      </optgroup>
                    </>
                  )}
                </select>
              </div>

              <button type="submit" className="btn btn-info w-100">Book Now</button>
            </form>
          </div>
        </div>

        {/* Slider Section */}
        <div className="col-lg-8 col-md-6">
          <div className="card shadow-sm" style={{ height: '500px' }}>
            <Slider {...sliderSettings}>
              {images.map((image, index) => (
                <div key={index} style={{ position: 'relative' }}>
                  <img
                    src={image}
                    alt={`Banner ${index + 1}`}
                    className="img-fluid"
                    style={{ width: '100%', height: '500px', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;